import React from 'react'
import { Card } from './card'
import { DonutChart } from './donut-chart'
import { LabeledNumber } from './labeled-number'
import { DonutChartLegend as Legend } from '../../../components'
import colors from '../../../utils/colors'

const total = 232
const data = [
  {name: 'Pemerintah', value: total*70/100},
  {name: 'Donor', value: total*10/100},
  {name: 'NGO', value: total*10/100},
  {name: 'Swasta', value: total*5/100},
  {name: 'Media', value: total*5/100},
]
const COLORS = ['#FF5448', colors.green, '#FFC020', colors.blue, '#679b9b', '#70adb5']

const OrganizationSuperadmin = ({className}) => {
  return (
    <Card className={className}>
      <div className="flex justify-between mb-8">
        <h1 className="font-primary font-bold lg:text-lg mr-8">Organisasi</h1>
        <div className="text-primary underline text-xs lg:text-sm">View list</div>
      </div>
      <div className="flex">
        <div className="mr-10">
          <DonutChart width={93} height={93} data={data} total={total} colors={COLORS}/>
        </div>
        <div className="">
          <div className="mb-5">
            <LabeledNumber label="Total Programs" number={total}/>
          </div>
          <Legend data={data} total={total} colors={COLORS} />
        </div>
      </div>
    </Card>
  )
}

export { OrganizationSuperadmin }